import React from 'react'
import { StyledIcon } from '../StyledIcon'

const ShieldCheckedIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 48 48"
    a11yTitle={icon}
    size={size}
    color="dark-1"
    {...customProps}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-110.000000, -602.000000)">
        <g transform="translate(98.000000, 562.000000)">
          <g transform="translate(12.000000, 40.000000)">
            <path d="M24,2 L6,10 L6,22 C6,33.1 13.68,43.48 24,46 C34.32,43.48 42,33.1 42,22 L42,10 L24,2 Z M14.82,23.18 L12,26 L20,34 L36,18 L33.18,15.16 L20,28.34 L14.82,23.18 Z" />
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

export default ShieldCheckedIcon
